"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports["default"] = void 0;

var _extends2 = _interopRequireDefault(require("@babel/runtime/helpers/extends"));

var _defineProperty2 = _interopRequireDefault(require("@babel/runtime/helpers/defineProperty"));

var _react = _interopRequireDefault(require("react"));

var _classnames = _interopRequireDefault(require("classnames"));

var _material = require("@mui/material");

var _styles = require("@mui/styles");

var _Icon = _interopRequireDefault(require("./Icon/Icon"));

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { (0, _defineProperty2["default"])(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var useStyles = (0, _styles.makeStyles)(function (_ref) {
  var spacing = _ref.spacing,
      palette = _ref.palette;
  return {
    avatar: {
      backgroundColor: palette.orange.main,
      width: 46,
      height: 46,
      marginRight: spacing(2)
    },
    icon: {
      color: 'white'
    },
    root: {
      width: 420,
      marginLeft: spacing(2),
      marginRight: spacing(2)
    },
    cancelButton: {
      backgroundColor: 'transparent',
      border: "1px solid ".concat(palette.divider),
      boxShadow: 'none',
      marginRight: spacing(2),
      height: 48,
      padding: spacing(1, 3),
      '&:hover': {
        backgroundColor: palette.grey.A200
      }
    },
    submitButton: {
      boxShadow: 'none',
      height: 48,
      padding: spacing(1, 3)
    },
    infoAvatar: {
      backgroundColor: palette.orange.main
    },
    warningAvatar: {
      backgroundColor: palette.red.main
    },
    successAvatar: {
      backgroundColor: palette.green.fruitSalad
    },
    infoRoot: {
      borderTop: "4px solid ".concat(palette.orange.main)
    },
    warningRoot: {
      borderTop: "4px solid ".concat(palette.red.main)
    },
    successRoot: {
      borderTop: "4px solid ".concat(palette.green.fruitSalad)
    },
    infoSubmitButton: {
      backgroundColor: palette.orange.main,
      '&:hover': {
        backgroundColor: palette.orange.light
      }
    },
    warningSubmitButton: {
      backgroundColor: palette.red.main,
      '&:hover': {
        backgroundColor: palette.error.dark
      }
    },
    successSubmitButton: {
      backgroundColor: palette.green.fruitSalad
    },
    actions: {
      padding: spacing(2)
    }
  };
});

/**
 * @function
 *
 * @param {object} props
 * @param {boolean} props.isOpen
 * @param {React.ReactNode} [props.children=null]
 * @param {string} [props.icon='exclamation-circle']
 * @param {string} props.title
 * @param {(event: MouseEvent<HTMLElement>) => void} props.onSubmit
 * @param {(event: MouseEvent<HTMLElement>) => void} props.onDiscard
 * @param {number|string} [props.width=400]
 * @param {object.<string, string>} [props.backdropStyles={}]
 * @param {object.<string, string>} [props.customClasses={}]
 * @param {string} props.submitButtonText
 * @param {string} props.cancelButtonText
 * @param {boolean} [props.isLoading=false]
 * @param {object} [props.buttonsProps={}]
 * @param {object} [props.submitButtonsProps={}]
 * @param {object} [props.discardButtonsProps={}]
 * @param {object} [props.DialogProps={}]
 * @param {'info' | 'warning'} [props.variant='info']
 * @param {React.ReactNode} [props.afterActions=null]
 * @param {object.<string, string | number>} [props.paperStyles={}]
 *
 * @returns {React.ReactElement}
 *
 * @example
 * // TODO: Write example
 */
var ModalConfirmationMessage = function ModalConfirmationMessage(_ref2) {
  var isOpen = _ref2.isOpen,
      children = _ref2.children,
      _ref2$icon = _ref2.icon,
      icon = _ref2$icon === void 0 ? 'exclamation-circle' : _ref2$icon,
      title = _ref2.title,
      onSubmit = _ref2.onSubmit,
      _ref2$onDiscard = _ref2.onDiscard,
      onDiscard = _ref2$onDiscard === void 0 ? function () {} : _ref2$onDiscard,
      _ref2$width = _ref2.width,
      width = _ref2$width === void 0 ? 400 : _ref2$width,
      _ref2$backdropStyles = _ref2.backdropStyles,
      backdropStyles = _ref2$backdropStyles === void 0 ? {} : _ref2$backdropStyles,
      _ref2$customClasses = _ref2.customClasses,
      customClasses = _ref2$customClasses === void 0 ? {} : _ref2$customClasses,
      _ref2$submitButtonTex = _ref2.submitButtonText,
      submitButtonText = _ref2$submitButtonTex === void 0 ? 'OK' : _ref2$submitButtonTex,
      _ref2$cancelButtonTex = _ref2.cancelButtonText,
      cancelButtonText = _ref2$cancelButtonTex === void 0 ? '' : _ref2$cancelButtonTex,
      _ref2$isLoading = _ref2.isLoading,
      isLoading = _ref2$isLoading === void 0 ? false : _ref2$isLoading,
      buttonsProps = _ref2.buttonsProps,
      submitButtonsProps = _ref2.submitButtonsProps,
      discardButtonsProps = _ref2.discardButtonsProps,
      DialogProps = _ref2.DialogProps,
      _ref2$variant = _ref2.variant,
      variant = _ref2$variant === void 0 ? 'info' : _ref2$variant,
      afterActions = _ref2.afterActions,
      paperStyles = _ref2.paperStyles;
  var classes = useStyles();

  var localBackdropStyles = _objectSpread({
    top: 80,
    left: 'initial',
    background: 'white',
    opacity: 0.8,
    width: width
  }, backdropStyles);

  return /*#__PURE__*/_react["default"].createElement(_material.Slide, {
    direction: "up"
  }, /*#__PURE__*/_react["default"].createElement(_material.Dialog, (0, _extends2["default"])({
    style: {
      width: width,
      left: 'initial',
      visibility: 'visible'
    },
    BackdropProps: {
      style: localBackdropStyles
    },
    PaperProps: {
      elevation: 1,
      square: false,
      classes: {
        root: (0, _classnames["default"])(classes.root, classes["".concat(variant, "Root")], customClasses.root)
      },
      style: paperStyles
    },
    disablePortal: true,
    open: isOpen
  }, DialogProps), /*#__PURE__*/_react["default"].createElement(_material.DialogTitle, null, /*#__PURE__*/_react["default"].createElement(_material.Box, {
    display: "flex",
    flexDirection: "row",
    justifyContent: "flex-start",
    alignItems: "center"
  }, icon && /*#__PURE__*/_react["default"].createElement(_material.Avatar, {
    className: (0, _classnames["default"])(classes.avatar, classes["".concat(variant, "Avatar")], customClasses.avatar)
  }, /*#__PURE__*/_react["default"].createElement(_Icon["default"], {
    className: (0, _classnames["default"])(classes.icon, customClasses.icon),
    icon: icon
  })), /*#__PURE__*/_react["default"].createElement(_material.Typography, {
    "data-testid": "modalConfirmationTitle",
    className: (0, _classnames["default"])('H3-Dark', customClasses.title)
  }, title))), /*#__PURE__*/_react["default"].createElement(_material.DialogContent, null, children), /*#__PURE__*/_react["default"].createElement(_material.DialogActions, {
    className: (0, _classnames["default"])(classes.actions, customClasses.actions)
  }, cancelButtonText && /*#__PURE__*/_react["default"].createElement(_material.Button, (0, _extends2["default"])({
    "data-testid": "modalConfirmationCancelButton",
    variant: "contained",
    className: (0, _classnames["default"])(classes.cancelButton, customClasses.cancelButton),
    disabled: isLoading,
    onClick: onDiscard
  }, buttonsProps, discardButtonsProps), /*#__PURE__*/_react["default"].createElement("span", {
    className: "Body-Regular-Center-Link"
  }, cancelButtonText)), /*#__PURE__*/_react["default"].createElement(_material.Button, (0, _extends2["default"])({
    "data-testid": "modalConfirmationSubmitButton",
    variant: "contained",
    className: (0, _classnames["default"])(classes.submitButton, classes["".concat(variant, "SubmitButton")], customClasses.submitButton),
    autoFocus: true,
    disabled: isLoading,
    onClick: onSubmit
  }, buttonsProps, submitButtonsProps), /*#__PURE__*/_react["default"].createElement("span", {
    className: "Body-Regular-Center-White"
  }, submitButtonText))), afterActions));
};

var _default = ModalConfirmationMessage;
exports["default"] = _default;